"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
exports.default = {
    "THEME": "Flow",
    "TRADEMARK": "\u00A9 ".concat(moment().format("YYYY"), " Flow is a registered trademark of Liverpool Victoria General Insurance Group. Registered address: 57 Ladymead, Guildford, Surrey, GU1 1DB."),
    "WHATEVER_YOU_DECIDE": "Whatever you decide, we’ll go with the Flow.",
    "COMPLAINT_EMAIL": "customerrelations_flow@lv.co.uk",
    "HELP_EMAIL": "flowinsurance@lv.co.uk",
    "UNDERWRITER": "Comprehensive cover, underwritten by LV="
};
//# sourceMappingURL=resource.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/resources/Flow/resource.js
// module id = 2527
// module chunks = 0